export const GET_SUMMARIES_REQUEST = 'GET_SUMMARIES_REQUEST'
export const GET_SUMMARIES_SUCCESS = 'GET_SUMMARIES_SUCCESS'
export const GET_SUMMARIES_FAILURE = 'GET_SUMMARIES_FAILURE'

export const RESET_SUMMARIES = 'RESET_SUMMARIES'